import Constants from "../components.constants.js"
import store from "../store/index.js"

export class QuickAccessPanel {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.quickAccessPanelType
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerQuickAccessPanel", this.toJSON())
    }

}

export class OverflowMenu {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, registerNow = false, iconUrl = null, dialogRequired = false) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.dialogRequired = dialogRequired
        this.type = Constants.OverflowMenuType
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            dialogRequired: this.dialogRequired,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerOverflowMenu", this.toJSON())
    }

}

export class SettingsSideMenu {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, componentName, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.settingsSideMenu
        this.componentName = componentName
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type,
            componentName: this.componentName
        }
    }

    register() {
        store.commit("registry/registerSettingsSidemenu", this.toJSON())
    }

}

export class UserPreferencesSidemenu {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null, iconSvgCallback = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.iconSvgCallback = iconSvgCallback
        this.type = Constants.preferencesSidemenu
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            iconSvgCallback: this.iconSvgCallback,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerPreferenceSidemenu", this.toJSON())
    }

}

export class FloatingMenu {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.floatingMenu
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerFloatingMenu", this.toJSON())
    }
}

export class BinContextMenu {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, requiredPermissions, requiredStates, status, supportedResources, supportedTypes, targetType, iconUrl = null, sub_menu = "DEFAULT", dialogRequired = false, multiple_selection_support = false, supported_mime_types=[], positionPriority = 1001) {
        this.id = id
        this.pluginName = pluginName
        this.action_name = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.binsContextMenu
        this.dialogRequired = dialogRequired
        this.requiredPermissions = requiredPermissions
        this.requiredStates = requiredStates
        this.status = status
        this.supportedResources = supportedResources
        this.supportedTypes = supportedTypes
        this.targetType = targetType
        this.sub_menu = sub_menu
        this.multiple_selection_support = multiple_selection_support
        this.position_priority = positionPriority
        if (supported_mime_types){
            this.supported_mime_types = supported_mime_types
        }else{
            this.supported_mime_types = []
        }
        
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            action_name: this.action_name,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type,
            dialogRequired: this.dialogRequired,
            requiredPermissions: this.requiredPermissions,
            requiredStates: this.requiredStates,
            status: this.status,
            supportedResources: this.supportedResources,
            supportedTypes: this.supportedTypes,
            targetType: this.targetType,
            multiple_selection_support: this.multiple_selection_support,
            supported_mime_types: this.supported_mime_types,
            position_priority:this.position_priority
        }
    }

    register() {
        if (this.sub_menu == "DEFAULT") {
            store.commit("registry/registerBinContextMenu", this.toJSON())
        } else if (this.sub_menu == "MOREACTIONS") {
            store.commit("registry/registerBinsMoreActionsContextMenu", this.toJSON())
        } else if (this.sub_menu == "NEWOPTION") {
            store.commit("registry/registerBinsNewActionsContextMenu", this.toJSON())
        } else if (this.sub_menu == "IMPORTOPTION") {
            store.commit("registry/registerBinsImportActionsContextMenu", this.toJSON())
        }
         else if (this.sub_menu == "SHAREACTIONS") {
            store.commit("registry/registerBinsShareActionsContextMenu", this.toJSON())
        } else if(this.sub_menu == "AITOOLACTIONS") {
            store.commit("registry/registerAIToolActionsContextMenu", this.toJSON())
        } else if(this.sub_menu == "OPENWITHACTIONS") {
            store.commit("registry/registerOpenWithActionsContextMenu", this.toJSON())
        } else if(this.sub_menu == "CATALOGICON") {
            store.commit("registry/registerCatalogIconActionsContextMenu", this.toJSON())
        } else if(this.sub_menu == "EXPORTOPTION"){
            store.commit("registry/registerExportActionsContextMenu", this.toJSON())
        }
    }

    registerAsMoreActions() {
        store.commit("registry/registerBinsMoreActionsContextMenu", this.toJSON())
    }

    registerAsShareActions() {
        store.commit("registry/registerBinsShareActionsContextMenu", this.toJSON())
    }

    registerAsAIToolsActions() {
        store.commit("registry/registerAIToolActionsContextMenu", this.toJSON())
    }

    registerAsOpenWithActions() {
        store.commit("registry/registerOpenWithActionsContextMenu", this.toJSON())
    }

    registerAsCatalogIconActions(){
        store.commit("registry/registerCatalogIconActionsContextMenu", this.toJSON())
    }

    registerAsExportActions(){
        store.commit("registry/registerExportActionsContextMenu", this.toJSON())
    }
}

export class SystemSettingsMenu {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.systemSettingsMenu
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerSystemSettingsMenu", this.toJSON())
    }

}


export class PropertiesTopNav {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.propertiesTopNav
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerPropertiesTopNav", this.toJSON())
    }

}

export class DialogData {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.externalPluginDialog
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerDialogForMediaBrowse", this.toJSON())
    }

}
export class ImportExportSettingsMenu {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.importExportMenu
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerImportExportSettingsMenu", this.toJSON())
    }

}
export class ShareTopMenu {

    constructor(id, pluginName, label, onEvents, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.shareTopMenu
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            onEvents: this.onEvents,
            iconSvgCallback: this.iconSvgCallback,
            iconUrl: this.iconUrl,
            type: this.type
        }
    }

    register() {
        store.commit("registry/registerShareExternalPlugins", this.toJSON())
    }

}

export class ReportsSidemenu {

    constructor(id, pluginName, label, iconSvgCallback, onEvents, componentName, registerNow = false, iconUrl = null) {
        this.id = id
        this.pluginName = pluginName
        this.label = label
        this.iconSvgCallback = iconSvgCallback
        this.onEvents = onEvents
        this.iconUrl = iconUrl
        this.type = Constants.reportsSideMenuType
        this.componentName = componentName
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            pluginName: this.pluginName,
            label: this.label,
            iconSvgCallback: this.iconSvgCallback,
            onEvents: this.onEvents,
            iconUrl: this.iconUrl,
            type: this.type,
            componentName: this.componentName
        }
    }

    register() {
        store.commit("registry/registerReportsSidemenu", this.toJSON())
    }

}


export class dashboardWidgets {

    constructor(id, widgetName,loadType,widgetNameAsId,classname = '', styles = '', registerNow = false) {
        this.id = id,
        this.widgetName = widgetName
        this.type = Constants.dashboardWidgetsType
        this.loadType = loadType
        this.classname = classname
        this.styles = styles
        if (registerNow) {
            this.register()
        }
    }

    toJSON() {
        return {
            id: this.id,
            widgetName: this.widgetName,
            loadType: this.loadType,
            type: this.type,
            classname: this.classname,
            styles: this.styles
        }
    }

    register() {
        store.commit("registry/registerDashboardWidgets", this.toJSON())
    }

}